import BaseSyncError from "scripts/exceptions/baseSyncError";

class ConflictSyncError extends BaseSyncError {}

export default ConflictSyncError;
